import moment from 'moment';
import * as Yup from 'yup';
import _ from 'lodash';

function validateValues(values) {
    let safeValues = _.cloneDeep(values);

    const validValues = {
        id: values.id,
        customerId: safeValues.customerId,
        extraWorkItemId: safeValues.extraWorkItemId,
        timestamp: moment(safeValues.timestamp).format(),
        unit: safeValues.unit,
        pricePerUnit: safeValues.pricePerUnit,
        totalPrice: safeValues.totalPrice,
        quantity: safeValues.quantity,
        remark: safeValues.remark,
    };
    return validValues;
}

const validationSchema = (t, selectedExtraWorkItem) =>
    Yup.object().shape({
        timestamp: Yup.date()
            .required(t('errors.RequiredField'))
            .test({
                name: 'isInPeriod',
                params: {selectedExtraWorkItem},
                message: () =>
                    t('errors.MustBeInsideEwiValidityPeriod', {
                        EWIStartDate: moment(selectedExtraWorkItem.startDate).format('DD-MM-YYYY'),
                        EWIEndDate: moment(selectedExtraWorkItem.endDate).format('DD-MM-YYYY'),
                    }),
                test: (value) => {
                    if (selectedExtraWorkItem == null) return true;
                    return (
                        moment(value).isSameOrAfter(moment(selectedExtraWorkItem.startDate)) &&
                        moment(value).isSameOrBefore(moment(selectedExtraWorkItem.endDate))
                    );
                },
            }),
        extraWorkItemId: Yup.string().required(t('errors.RequiredField')),
        quantity: Yup.string()
            .required(t('errors.RequiredField'))
            .test('isZeroValue', t('errors.RequiredField'), (value) => {
                return value !== '0';
            })
            .test('is integer >= 0', t('errors.MustBeIntegerGreaterOrEqualZero'), (value) => {
                const number = Number(value);
                return _.isNumber(number) && _.isInteger(number) && number >= 0;
            }),
    });

export {validationSchema, validateValues};
